/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { onMounted, onUnmounted, ref } from 'vue'

const useScreen = () => {
  const designWidth = 375
  const screenWidth = ref(window.screen.availWidth)
  const screenHeight = ref(window.screen.availHeight)
  const rootScale = ref(window.screen.availWidth / designWidth)
  const update = () => {
    screenWidth.value = window.screen.availWidth
    screenHeight.value = window.screen.availHeight
    rootScale.value = screenWidth.value / designWidth
  }

  onMounted(async () => {
    window.addEventListener('resize', update)
  })
  onUnmounted(() => {
    window.removeEventListener('resize', update)
  })
  return { designWidth, screenWidth, screenHeight, rootScale }
}

export default useScreen
